// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ControlHero_wrapper__zp9bB","inner":"ControlHero_inner__n9hBP","texts":"ControlHero_texts__ueVZ7"};